import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { combineStates, siteSettingsState, popupDispatcher } from '../../../store';
import { connect } from 'react-redux';
import { Email } from '.';
import { translate } from '../../../services';
import { Box, Dialog, IconButton } from '@mui/material';
import { closePopup } from '../../../../style/images';
export class requestSupportComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      showPopup: false,
    }
  }
  togglePopup = () =>{
  // this.props.setPopup( {
  //   title: translate( 'EMAILPOPUPTITLE' ),
  //   component: <Email />,
  //   showHeader: true,
  //   keepOpen: true } );
  this.setState({showPopup:!this.state.showPopup})
  }
  render() {
    const {  siteSettings, className } = this.props;
    return <div  style ={{cursor : "pointer", padding: "10px"}} className = {className}>
             <span className='black' title = { translate( 'FEEDBACKTOOLTIP' ) }  onClick = {this.togglePopup}>{ translate( 'contact us' ) }</span>
             <Dialog open={this.state.showPopup} onClose={this.togglePopup} 
              PaperProps={{sx:{
                overflow:"hidden",
                alignSelf:"start",
                top:{md:200, xs:145},
                margin:"20px",
              }}}
              >
                <IconButton sx={{width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}, position: "absolute",
                    right: "11px",
                    top: "12px"}} onClick={this.togglePopup}>
                  <Box component="img" src={closePopup} sx={{width:{md:"24px", xs:"18px"}, height:{md:"24px", xs:"18px"}}}></Box>
                </IconButton>
                <Email/>
            </Dialog>   
           </div>
  }
}
requestSupportComponent.propTypes = {
  siteSettings: PropTypes.shape( {
  emailToConfiguration: PropTypes.shape( {
    emailTo: PropTypes.string,
    subject: PropTypes.string,
    copyTo: PropTypes.string
  } )
} )
}

export const RequestSupport = connect( combineStates(  siteSettingsState ), popupDispatcher) (requestSupportComponent) ;